import { createContext } from 'react';
export var defaultTableWrapping = 'horizontal';
export var tableWrappingContext = createContext(defaultTableWrapping);
